import React, { ComponentType } from 'react';
import { makeSpinnerDefaultLoader } from '../../common/SpinnerLoader';

function makeLoader<P>(load: () => Promise<{ default: ComponentType<P> }>): ComponentType<P> {
  const SpinnerLoader = makeSpinnerDefaultLoader(load);

  return (props: P) =>
    <SpinnerLoader height="32">{(LoadedComponent) =>
      <LoadedComponent {...props} />
    }</SpinnerLoader>;
}

export const ChromeToolbar = makeLoader(() => import('./ChromeToolbar'));
export const ChromeDialog = makeLoader(() => import('./ChromeDialog'));
export const FirefoxToolbar = makeLoader(() => import('./FirefoxToolbar'));
export const FirefoxDialog = makeLoader(() => import('./FirefoxDialog'));
export const FirefoxPermission = makeLoader(() => import('./FirefoxPermission'));
export const SafariMenu = makeLoader(() => import('./SafariMenu'));
export const SafariDialog = makeLoader(() => import('./SafariDialog'));
